export default __webpack_public_path__ + "static/media/bnr6.725df251.jpg";